// import React from 'react';
// import InputGroup from 'react-bootstrap/InputGroup';
// import Form from 'react-bootstrap/Form';

// export default function SearchBox({ onSearch, placeholder = 'Search...', value = '' }) {
//   return (
//     <div className="searchbox">
//       <InputGroup className="">
//         <Form.Control
//           placeholder={placeholder}
//           aria-label="Search"
//           onChange={(e) => onSearch(e.target.value)}
//           value={value || ''}
//         />
//         <InputGroup.Text>
//           <span style={{ cursor: 'pointer' }}>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="16"
//               height="16"
//               fill="currentColor"
//               className="bi bi-search"
//               viewBox="0 0 16 16"
//             >
//               <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
//             </svg>
//           </span>
//         </InputGroup.Text>
//       </InputGroup>
//     </div>
//   );
// }

import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export default function SearchBox({ onSearch, placeholder = 'Search...',  value: propValue = '' }) {
    const [value, setValue] = useState(propValue);

      useEffect(() => {
    setValue(propValue);
  }, [propValue]);

 const handleClear = () => {
    setValue('');
    onSearch('');
  };
  return (
    <div className="searchbox">
      <TextField
        fullWidth
        placeholder={placeholder}
        variant="outlined"
        value={value || ''}
      onChange={(e) => setValue(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: '30px',
            paddingRight: 0, // ensures button fits cleanly
            '& input': {
              padding: '4px 8px',
              height: '100%',
              boxSizing: 'border-box',
            },
            '& fieldset': {
              borderColor: '#EAEAEA',
            },
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ height: '100%', marginRight: 0 }}>
                 {value && (
                <IconButton
                  onClick={handleClear}
                  size="small"
                  sx={{ marginRight: 0 }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
              <Button
                variant="contained"
                              onClick={() => onSearch(value)}

                sx={{
                  backgroundColor: 'primary.main',
                  minWidth: '60px',
                  height: '30px',
                  borderRadius: '4px',
                  boxShadow: 'none',
                  textTransform: 'none',
                  fontSize: '13px',
                  '&:hover': {
                    backgroundColor: '#3048c9',
                  },
                }}
              >
                Search
              </Button>
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}
